// src/pages/ResetPassword.js
import React, { useMemo, useState } from "react";

const API_BASE = "https://textshare-node.rupioo.com";

export default function ResetPassword() {
  const params = useMemo(() => {
    const hash = window.location.hash || "";
    const q = hash.includes("?") ? hash.split("?")[1] : "";
    return new URLSearchParams(q);
  }, []);
  const emailFromLink = params.get("email") || "";
  const tokenFromLink = params.get("token") || "";

  const [email] = useState(emailFromLink);
  const token = tokenFromLink; // used internally only (no UI)
  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const missingParams = !email || !token;

  async function submit() {
    setErr("");
    setMsg("");
    if (!newPassword || !confirm) {
      setErr("Please enter and confirm your new password.");
      return;
    }
    if (newPassword !== confirm) {
      setErr("Passwords do not match.");
      return;
    }
    setBusy(true);
    try {
      const res = await fetch(`${API_BASE}/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: email.trim(),
          token: token.trim(), // still sent, just not shown in UI
          newPassword,
        }),
      });
      const data = await res.json();
      if (!res.ok) {
        throw new Error(data?.error || data?.message || "Reset failed");
      }
      setMsg("Password reset successful. You can now log in in the app.");
      setNewPassword("");
      setConfirm("");
      window.location.replace("/");
    } catch (e) {
      setErr(e.message || "Reset failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f6f4fb",
        padding: 16,
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 420,
          background: "#fff",
          border: "1px solid #e5e7eb",
          borderRadius: 12,
          padding: 16,
          boxShadow: "0 1px 2px rgba(0,0,0,0.04), 0 2px 4px rgba(0,0,0,0.04)",
        }}
      >
        <h2 style={{ margin: 0, marginBottom: 8, color: "#111827" }}>
          Reset Password
        </h2>
        <p style={{ marginTop: 0, color: "#6b7280" }}>
          Enter your new password below.
        </p>

        {missingParams ? (
          <div
            style={{
              background: "#FEF2F2",
              color: "#991B1B",
              border: "1px solid #FECACA",
              borderRadius: 8,
              padding: "10px 12px",
              marginTop: 8,
            }}
          >
            Invalid reset link. Missing <code>email</code> or <code>token</code>{" "}
            in the URL.
          </div>
        ) : (
          <>
            {/* Email (read-only) */}
            <div style={{ marginTop: 12 }}>
              <label
                style={{ display: "block", fontSize: 13, color: "#374151" }}
              >
                Email
              </label>
              <input
                type="email"
                value={email}
                disabled
                style={{
                  width: "100%",
                  boxSizing: "border-box",
                  padding: "10px 12px",
                  border: "1px solid #e5e7eb",
                  borderRadius: 8,
                  marginTop: 4,
                  background: "#f9fafb",
                  color: "#6b7280",
                }}
              />
            </div>

            {/* New password */}
            <div style={{ marginTop: 10 }}>
              <label
                style={{ display: "block", fontSize: 13, color: "#374151" }}
              >
                New password
              </label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Enter new password"
                style={{
                  width: "100%",
                  boxSizing: "border-box",
                  padding: "10px 12px",
                  border: "1px solid #e5e7eb",
                  borderRadius: 8,
                  marginTop: 4,
                }}
              />
            </div>

            {/* Confirm password */}
            <div style={{ marginTop: 10 }}>
              <label
                style={{ display: "block", fontSize: 13, color: "#374151" }}
              >
                Confirm password
              </label>
              <input
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                placeholder="Re-enter new password"
                style={{
                  width: "100%",
                  boxSizing: "border-box",
                  padding: "10px 12px",
                  border: "1px solid #e5e7eb",
                  borderRadius: 8,
                  marginTop: 4,
                }}
              />
            </div>

            {err ? (
              <div
                style={{
                  background: "#FEF2F2",
                  color: "#991B1B",
                  border: "1px solid #FECACA",
                  borderRadius: 8,
                  padding: "10px 12px",
                  marginTop: 12,
                }}
              >
                {err}
              </div>
            ) : null}
            {msg ? (
              <div
                style={{
                  background: "#ECFDF5",
                  color: "#065F46",
                  border: "1px solid #A7F3D0",
                  borderRadius: 8,
                  padding: "10px 12px",
                  marginTop: 12,
                }}
              >
                {msg}
              </div>
            ) : null}

            <button
              onClick={submit}
              disabled={busy}
              style={{
                marginTop: 14,
                width: "100%",
                padding: "10px 12px",
                background: "#4F46E5",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                cursor: "pointer",
                opacity: busy ? 0.7 : 1,
              }}
            >
              {busy ? "Resetting..." : "Reset Password"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
